import { i18nKeys } from 'translationTypes'
import i18n from '../../../i18n'

export default {
  heroTitleCity: () => i18n.t(i18nKeys.drivingOpportunities_heroTitleCity),
  heroTitleDefault: () =>
    i18n.t(i18nKeys.drivingOpportunities_heroTitleDefault),
  heroContentCity: (city: string) =>
    i18n.t(i18nKeys.drivingOpportunities_heroContentCity, { city }),
  heroContentDriving: () =>
    i18n.t(i18nKeys.drivingOpportunities_heroContentDriving),
}
